'use client';

import { useMemo, useState } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { SeoExam } from '@medprev-web-app/api-graphql-client';

import { SeoExamCard } from '@/app/(main)/(pages)/(institucional)/(index)/exames/_components/seo-exam-card.component';
import { ClientListFilterInput } from '@/components/ui/list-filter-input/client-list-filter-input.component';

export interface FilterableExamListProps {
  exams: SeoExam[];
  titleBaseUrl: string;
  itemBaseUrl: string;
  placeholder?: string;
}

function filterExams(exams: SeoExam[], term: string): SeoExam[] {
  const t = term.trim().toLowerCase();
  if (!t) {
    return exams;
  }
  return exams.filter(
    (e) =>
      e != null
      && ((e.name?.toLowerCase().includes(t) ?? false) || (e.slug?.toLowerCase().includes(t) ?? false)),
  );
}

export function FilterableExamList({
  exams,
  titleBaseUrl,
  itemBaseUrl,
  placeholder = 'Busque pelo exame',
}: FilterableExamListProps) {
  const [filter, setFilter] = useState('');

  const filtered = useMemo(() => filterExams(exams, filter), [exams, filter]);

  return (
    <div className="md:space-y-6">
      <div className="px-5 md:px-0 mb-6">
        <ClientListFilterInput
          value={filter}
          onChange={setFilter}
          placeholder={placeholder}
          className="max-w-md"
        />
      </div>

      {filtered?.length
        ? filtered.map((exam, index) => (
            <SeoExamCard
              key={exam.id}
              exam={exam}
              titleBaseUrl={titleBaseUrl}
              itemBaseUrl={itemBaseUrl}
              isFirst={index === 0}
            />
          ))
        : (
            <p
              className="px-5 md:px-0 text-gray-600"
              role="status"
              data-testid={DataTestIdEnum.INDEX_LIST_EMPTY_STATE}
            >
              Nenhum exame encontrado para o filtro informado.
            </p>
          )}
    </div>
  );
}
